import { makeRequest, CommonRequestOptions } from '~/monolith-api/makeRequest';
import { createErrorMessageTypeGuard } from '~/monolith-api/createErrorMessageTypeGuard';

export const USER_PRIVILEGES = [
   'admin',
   'author & mod',
   'author',
   'contributor',
   'moderator',
   'user',
] as const;

export type EditUserPrivilege = (typeof USER_PRIVILEGES)[number];

export type editMultipleUsersPrivilegeOptions = CommonRequestOptions & {
   userids: number[];
   privilege: EditUserPrivilege;
};

export async function editMultipleUsersPrivilege({
   userids,
   privilege,
   ...common
}: editMultipleUsersPrivilegeOptions): Promise<void> {
   return makeRequest('put', 'users/manage/privilege', {
      ...common,
      body: {
         userids: userids,
         privilege: privilege,
      },
   });
}

export type EditMultipleUsersPrivilegeErrorCode =
   | 'user_manage.edit_user_privilege.user_is_self'
   | 'user_manage.edit_user_privilege.invalid_user'
   | 'user_manage.edit_user_privilege.max_privileged_users'
   | 'user_manage.edit_user_privilege.max_standard_user';

editMultipleUsersPrivilege.errorMessages =
   createErrorMessageTypeGuard<EditMultipleUsersPrivilegeErrorCode>();
